export default __webpack_public_path__ + "static/media/welfare-basic.14d3ef29.png";